import biosBanner from '../img/randalyn-hill-neon-crop_450.jpg';
import { detailsBios } from '../data/Data';
import Card from '../UI/Card';
import Team from '../elements/team/Team';

const Bios = () => {
  return (
    <>
      <div>
        <div className="hero-bios">
          <div id="hero">
            <img className="hero-img" src={biosBanner} alt="neon sign" />
          </div>
        </div>
      </div>

      <div className="container team-intro">
        <Team />
      </div>

      {/* Bio Section */}
      <section className="bio">
        <div id="container" className="bio__container">
          {detailsBios.map(({ id, name, tag, title, byline, items }) => (
            <div key={id}>
              <div id={tag} style={{ scrollMarginTop: '80px' }} />
              <Card className="bio">
                <h2 className="color-blue">{name}</h2>
                <div className='title__byline'>
                  <h3 className="color-blue">{title}</h3>
                  <p className='smaller'>{byline}</p>
                </div>
                <ul>
                  {items.map(({ item }, index) => (
                    <li key={index} className="bio">{item}</li>
                  ))}
                </ul>
              </Card>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default Bios;
